import React from 'react';
import { FileJpg, FilePng, FilePdf, FileDoc } from 'styled-icons/boxicons-solid';
import { File, Error, Upload } from 'styled-icons/boxicons-regular';
import { UIProps } from '../../types/StyledProps';
import { IconType } from './icon-type';

export interface StyledIconProps extends React.PropsWithRef<React.SVGProps<SVGSVGElement>> {
  size?: number | string;
  title?: string | null;
}

const IconComponents = {
  [IconType.Generic]: Error,
  [IconType.File]: File,
  [IconType.FileJpg]: FileJpg,
  [IconType.FileDoc]: FileDoc,
  [IconType.FilePdf]: FilePdf,
  [IconType.FilePng]: FilePng,
  [IconType.Upload]: Upload,
};

export type UnstyledIconProps = {
  type: IconType;
} & UIProps & StyledIconProps;

function UnstyledIcon({
  type = IconType.Generic,
  size = 90,
  ...props
}: UnstyledIconProps) {
  const Icon = IconComponents[type];

  return (
    <Icon
      size={size}
      {...props}
    />
  );
}

export default UnstyledIcon;
